import { Injectable } from '@angular/core';
import {
  HttpInterceptor,
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpErrorResponse
} from '@angular/common/http';
import { from, Observable, take, throwError } from 'rxjs';
import { switchMap, catchError } from 'rxjs/operators';
import { getAuth } from 'firebase/auth';
import { AngularFireAuth } from '@angular/fire/compat/auth';
import { AuthErrorHandlerService } from '../_services/auth-error-handler.service';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {

  constructor(
    private afAuth: AngularFireAuth,
    private authErrorHandler: AuthErrorHandlerService
  ) {
  }


  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return this.afAuth.idToken.pipe(
      take(1),
      switchMap((token) => {
        if (!token) {
          return next.handle(req);
        }
        const cloned = req.clone({
          setHeaders: {
            ['Authorization']: `Bearer ${token}`,
          },
        });
        return next.handle(cloned).pipe(
          catchError((error: HttpErrorResponse) => {
            if (this.authErrorHandler.isAuthenticationError(error)) {
              // Handle authentication error centrally
              this.authErrorHandler.handleAuthenticationError('HTTP Interceptor');
            }
            return throwError(() => error);
          })
        );
      })
    );
  }
}
